import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
// import { EndCustomersController } from './end-customer.controller';
// import { EndCustomerService } from './end-customer.service';
// import {EndCustomers } from './end-customer.entity';
import {EndCustomersAdapter} from './dto/end-customer.adapter';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { EndCustomersService } from './end-customer.service';
import { BrandsInfo } from './brands.model';
import { Address } from '../customers/address.entity';
import { Brands } from './brands.entity';
import { EndCustomers } from './end-customer.entity';
import { EndCustomersController } from './end-customer.controller';
import { BrandsRepository } from './brands.repository';
import { LogsService } from '@gtpl/shared-services/user-logs';

@Module({
  imports: [
       TypeOrmModule.forFeature([EndCustomers,Brands]),
  ],
  controllers: [EndCustomersController],
  providers: [EndCustomersService,EndCustomersAdapter,ApplicationExceptionHandler,LogsService],
  exports: [EndCustomersService],
})
export class EndCustomersModule {}
